import React from "react";
import { Select } from "../../../../componentsv2/Select";

export default function SelectFormaPagamento({
  onChange,
  value,
  disabled = false,
  required = false,
}) {
  const options = [
    "Boleto",
    "Crédito - Parcelado",
    "Crédito - Vencimento",
    "Debito - Espécie",
    "Pix",
    "Transferencia Bancária",
  ];

  return (
    <Select
      required={required}
      disabled={disabled}
      onChange={onChange}
      value={value}
      label="Forma de Pagamento"
      variant="standard"
      arrayOptions={options}
      fullWidth
      MenuProps={{ disableScrollLock: true }}
    />
  );
}
